import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-298c350d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-order" }
const _hoisted_2 = { class: "np-panel-wrapper" }
const _hoisted_3 = { class: "schedule" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule__title" }, "Мы принимаем заказы", -1))
const _hoisted_5 = { class: "schedule__times times" }
const _hoisted_6 = { class: "time__day" }
const _hoisted_7 = {
  key: 0,
  class: "time__day-schedule"
}
const _hoisted_8 = { class: "time__time" }
const _hoisted_9 = { class: "time__time" }
const _hoisted_10 = {
  key: 1,
  class: "time__day-schedule"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time__time" }, "Выходной", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule__title" }, "на сайте и по телефонам", -1))
const _hoisted_14 = { class: "additional-links" }
const _hoisted_15 = { class: "additional-links__link link" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "link__icon" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "link__fake-icon" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "delivery"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "delivery__logo" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "delivery__title" }, "Бесплатная доставка", -1))
const _hoisted_21 = {
  key: 0,
  class: "delivery__description"
}
const _hoisted_22 = {
  key: 1,
  class: "receive-card"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "receive-card__logo" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "receive-card__title" }, "Все наши курьеры принимают к оплате банковские карты.", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "mo"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mo__logo" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mo__description" }, " Мы предоставляем скидку по Вашей Мо.Карте. Разные виды скидок не суммируются. ", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 3,
  class: "socials"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "socials__title" }, "Мы в соцсетях:", -1))
const _hoisted_32 = { class: "socials__links" }
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberPhonePanel = _resolveComponent("NumberPhonePanel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NumberPhonePanel, {
        phones: _ctx.companyStore.activeCompany.phones,
        "logo-url": 
          _ctx.companyStore.activeCompany.additionalLogoUrl || _ctx.companyStore.activeCompany.logoUrl
        
      }, null, 8, ["phones", "logo-url"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyStore.activeCompany.workScheduleGrouped, (workSchedule, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "times__item time"
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(workSchedule.name), 1),
            (workSchedule.schedule[0] || workSchedule.schedule[1])
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createTextVNode(" с "),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getFormatHours(workSchedule.schedule[0])), 1),
                  _createTextVNode(" до "),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getFormatHours(workSchedule.schedule[1])), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          ]))
        }), 128))
      ]),
      _hoisted_13
    ]),
    _createElementVNode("ul", _hoisted_14, [
      _createElementVNode("li", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_router_link, { to: { name: 'c-custom-pages', params: { customPage: 'delivery' } } }, {
          default: _withCtx(() => [
            _createTextVNode(" Условия оплаты и доставки ")
          ]),
          _: 1
        }),
        _hoisted_17
      ])
    ]),
    (_ctx.companyStore.activeCompany.hasCourierDelivery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _hoisted_20,
          (_ctx.companyStore.activeCompany.minOrderPrice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createTextVNode(" при минимальном заказе от " + _toDisplayString(_ctx.companyStore.activeCompany.minOrderPrice) + " руб. В зависимости от ", 1),
                _createVNode(_component_router_link, {
                  class: "underlined",
                  to: { name: 'c-delivery-zones' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" зоны доставки ")
                  ]),
                  _: 1
                }),
                _createTextVNode(", сумма бесплатной доставки может быть изменена. ")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.companyStore.activeCompany.hasOnlinePayment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
      : _createCommentVNode("", true),
    (_ctx.companyStore.activeCompany.hasMoCardDiscount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
      : _createCommentVNode("", true),
    (_ctx.companyStore.hasOneSocialLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            (_ctx.companyStore.activeCompany.facebook)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.companyStore.activeCompany.facebook,
                  target: "_blank",
                  rel: "nofollow",
                  class: "link facebook"
                }, null, 8, _hoisted_33))
              : _createCommentVNode("", true),
            (_ctx.companyStore.activeCompany.vk)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _ctx.companyStore.activeCompany.vk,
                  target: "_blank",
                  rel: "nofollow",
                  class: "link vk"
                }, null, 8, _hoisted_34))
              : _createCommentVNode("", true),
            (_ctx.companyStore.activeCompany.youtube)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: _ctx.companyStore.activeCompany.youtube,
                  target: "_blank",
                  rel: "nofollow",
                  class: "link youtube"
                }, null, 8, _hoisted_35))
              : _createCommentVNode("", true),
            (_ctx.companyStore.activeCompany.instagram)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  href: _ctx.companyStore.activeCompany.instagram,
                  target: "_blank",
                  rel: "nofollow",
                  class: "link instagram"
                }, null, 8, _hoisted_36))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}